import {
  MarketplaceOffersListResponse,
  MarketplaceOfferV2,
} from '../types/types';

export function serializeArrayParams(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => searchParams.append(key, String(v)));
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
}

export function removeUndefinedParams<T extends Record<string, unknown>>(
  params: T
): Partial<T> {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (
      value === undefined ||
      value === null ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return acc;
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {} as Partial<T>);
}

export function normalizeOffersResponse(
  response:
    | MarketplaceOfferV2[]
    | MarketplaceOffersListResponse
    | {
        data?: MarketplaceOfferV2[];
        total?: number;
        items?: MarketplaceOfferV2[];
      }
): MarketplaceOffersListResponse {
  if (Array.isArray(response)) {
    return {
      data: response,
      total: response.length,
    };
  }

  const data =
    response.data ??
    ('items' in response && Array.isArray(response.items)
      ? response.items
      : []);

  return {
    data,
    total: response.total ?? data.length,
  };
}
